export default [
  {
    path: '',
    name: 'call-vendor',
    meta: {
      header: 'Call a supplier',
      hideBackButton: true,
    },
    component: () => import('components/vendors/call-vendor-jobsite.vue')
  },
  {
    path: 'suppliers',
    name: 'call-vendor-suppliers',
    meta: {
      header: 'Suppliers',
      hideCloseButton: true,
    },
    component: () => import('components/vendors/call-vendor-suppliers.vue')
  },
  {
    path: 'confirm',
    name: 'call-vendor-confirm',
    meta: {
      header: 'Call supplier',
      hideCloseButton: true,
    },
    component: () => import('components/vendors/call-vendor-confirm.vue')
  },
  {
    path: 'calls',
    name: 'call-vendor-calls',
    meta: {
      header: 'Call supplier',
    },
    component: () => import('components/vendors/call-vendor-calls.vue')
  }
]
